import React from 'react';
import CircularProgressBar from './CircularProgressBar';

import './index.scss';

const getWindowDimensions = () => {
  const { innerWidth: width } = window;
  if (width > 768) {
    return { radius: 60, stroke: 13 };
  } else {
    return { radius: 45, stroke: 10 };
  }
};

const StatusBar = ({ formresponse, auth }) => {
  let device = getWindowDimensions();
  return (
    <div className="status-progress">
      <div className="progress-bar">
        <CircularProgressBar
          radius={device.radius}
          stroke={device.stroke}
          progress={formresponse.engagement_rate}
          color={'#3497D5'}
        />
        <div className="progress-bar_info">
          <div className="progress-bar_info_rate" style={{ color: '#5F6A79' }}>
            {formresponse.engagement_rate}%
          </div>
          <div className="progress-bar_info_label">Engagement Rate</div>
        </div>
      </div>

      <div className="progress-bar tab-space">
        <CircularProgressBar
          radius={device.radius}
          stroke={device.stroke}
          progress={formresponse.conversion_rate}
          color={'#21CDC9'}
        />
        <div className="progress-bar_info">
          <div className="progress-bar_info_rate" style={{ color: '#5F6A79' }}>
            {formresponse.conversion_rate}%
          </div>
          <div className="progress-bar_info_label">Conversion Rate</div>
        </div>
      </div>
    </div>
  );
};
export default StatusBar;
